<app-loader *ngIf="loadingCounter > 0; else contentTemplate" [@leave]></app-loader>

<ng-template #contentTemplate>
<div style="width: calc(100vw - 268px); margin-bottom: 32px" class="" >
<div class="grid nested-grid">
    <div class="col-6" [ngClass]="{'col-12': showRegionTable}" style="padding-bottom: 0!important;">
        <p-accordion class="w-full background-249" [activeIndex]="0" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
            <p-accordionTab iconPos="end">
                <ng-template pTemplate="header">
                    <div class="grid">
                    <div class="col-4">
                        <med-icon-aimbulance
                                size="48"
                                mode="square"
                        ></med-icon-aimbulance>
                    </div>

                    <div class="col-8">
                        <span class="white-space-nowrap postavka">
                            Розподіл &nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <br>
                        <div class="h10-text" style="display: flex; flex-direction: row; width: 14em">Статус:&nbsp; <img [src]="getPathToStatusImgTop(distribution?.status)" width="4" height="16" style="vertical-align: middle;"/>&nbsp;{{getStatus()}}</div>
                    </div>
                    </div>
                </ng-template>

                <div class="grid" style="margin: .5em .1em 0 .1em; border: 1px solid rgb(220, 220, 220); border-radius: 5px; height: 25vh">
                    <div class="col-6">
                        <span class="mobile-h10-text">
                            Виконавець розподілу
                        </span>
                        <br>
                        <span class="h10-text">
                            {{distribution?.originalAuthorName}}
                        </span>
                        <br>
                        <br>
                        <span class="mobile-h10-text">
                            Організація розподілу
                        </span>
                        <br>
                        <span class="h10-text">
                            {{distribution?.distributionType}}
                        </span>
                        <br>
                        <br>
                        <span class="mobile-h10-text">
                            Склад
                        </span>
                        <br>
                        <span class="h10-text">
                            {{distribution?.warehouseName}}
                        </span>
                    </div>
                    <div class="col-6">
                        <span class="mobile-h10-text">
                            Дата розподілу
                        </span>
                        <br>
                        <span class="h10-text">
                            {{distribution?.orderDate | date: 'dd.MM.yyyy'}}
                        </span>
                        <br>
                        <br>
                        <span class="mobile-h10-text">
                            Виконавець останніх змін
                        </span>
                        <br>
                        <span class="h10-text">
                            {{distribution?.changerName}}
                        </span>
                        <br>
                        <br>
                        <span class="mobile-h10-text">
                            Дата останніх змін
                        </span>
                        <br>
                        <span class="h10-text">
                            {{distribution?.updatedAt | date: 'dd.MM.yyyy'}}
                        </span>
                    </div>

                </div>
            </p-accordionTab>
        </p-accordion>
    </div>
    <div class="col-6" style="padding-bottom: 0!important;" *ngIf="!showRegionTable">
        <p-accordion class="w-full background-249" [activeIndex]="0" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
            <p-accordionTab iconPos="end">
                <ng-template pTemplate="header">
                    <div class="grid">
                        <div class="col-2">
                            <med-icon-docs
                                    size="48"
                                    mode="square"
                            ></med-icon-docs>
                        </div>

                        <div class="col-10 p-grid justify-content-center align-content-center">
                            <span class="white-space-nowrap postavka">
                                МНН у поточному розподілі
                            </span>
                        </div>
                    </div>
                </ng-template>

                <div class="grid" style="margin: .5em .1em 0 .1em;">
                    <div class="col12" style="width: 100%">
                        <div class="table-wrapper" style="margin-top: 0; width: 100%; height: 25vh">
                            <p-table
                                #dt
                                styleClass="p-datatable-sm"
                                [scrollable]="true"
                                scrollHeight="flex"
                                [value]="tableDistributionGood ? tableDistributionGood : []"
                                [tableStyle]="{ 'width': '100%' }"
                                [customSort]="true"
                                [lazy]="true"
                                [resizableColumns]="true"
                                columnResizeMode="expand"
                                [columns]="mnnTabHeader"
                                [reorderableColumns]="true"
                                (onColReorder)="saveColumnOrder('mnnColumnOrder', mnnTabHeader)">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <ng-container *ngFor="let column of mnnTabHeader">
                                        <th class="table-header-text-10px table-header-bg-grey" style="width: 20%" pReorderableColumn pResizableColumn>
                                            <div style="display: inline-block" class="flex align-items-center">
                                                {{ column.label }}&nbsp;
                                            </div>
                                        </th>
                                    </ng-container>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-row let-columns="columns">
                                    <tr class="table-content-text">
                                        <ng-container *ngFor="let col of columns">
                                        <td class="black-80 h10-text" *ngIf="col.key === '1'">
                                            <div class="flex-12rem">
                                                <span class="truncate-text">
                                                    {{row.mnnName}}
                                                </span>
                                            </div>

                                        </td>
                                        <td class="black-60 h10-text" *ngIf="col.key === '2'">
                                            {{row.mnnId}}
                                        </td>
                                        <td class="black-60 h10-text" *ngIf="col.key === '3'">
                                            {{row.remainQuantity}}
                                        </td>
                                        <td class="black-60 h10-text" *ngIf="col.key === '4'">
                                          {{row.cost}}
                                        </td>
                                        <td class="black-60 h10-text" *ngIf="col.key === '5'">
                                          {{row.multiple}}
                                        </td>
                                        <td *ngIf="col.key === '6'">
                                            <med-icon-check-circle-fill *ngIf="row['checked'] && !READONLY" size="16" style="cursor: pointer" class="text-green-100" (click)="checkDistributionGood(row.distributionGoodsId, true)"></med-icon-check-circle-fill>
                                            <med-icon-circle *ngIf="!row['checked'] && !READONLY" size="16" style="cursor: pointer" (click)="checkDistributionGood(row.distributionGoodsId, false)"></med-icon-circle>

                                          <med-icon-check-circle-fill *ngIf="row['checked'] && READONLY" size="16" class="text-green-100"></med-icon-check-circle-fill>
                                          <med-icon-circle *ngIf="!row['checked'] && READONLY" size="16"></med-icon-circle>
                                        </td>

                                        <td *ngIf="!READONLY && col.key === '7'">
                                            <med-icon-delete *ngIf="!row['checked']"
                                                             [ngStyle]="{'width': '16px', 'cursor': 'pointer'}"
                                                             (click)="removeDistributionGood(row.distributionGoodsId)"
                                                             (mouseenter)="iconDelete.show($event)" (mouseleave)="iconDelete.hide()"></med-icon-delete>
                                          <p-overlayPanel #iconDelete>
                                            <div class="flex items-center h10-text">
                                              Видалити
                                            </div>
                                          </p-overlayPanel>
                                        </td>
                                    </ng-container>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </p-accordionTab>
        </p-accordion>
    </div>
</div>
</div>

  <p-scrollPanel [style]="{ width: 'calc(100vw - 268px)', height: '70px' }">
<med-tab-group
        [options]="optionsTabGroup"
        [(value)]="optionsModel"
        (valueChange)="tabGroupChanged($event)">
    <ng-template medTemplate="tab" let-option>
       <div style="width: max-content; display: flex;">
        <med-icon-check  size="16" class="text-green-100" *ngIf="option.value.checked"></med-icon-check>
        &nbsp;
        <span class="truncate-15em">{{option.label}}</span>
        <span *ngIf="option.value.dosage">
            |&nbsp;{{option.value.dosage}}
        </span>
      &nbsp;
        <med-icon-alert-error size="16" class="text-red-100" [pTooltip]="validationTip" *ngIf="mnnHasValidationErrors(option.value.distributionGoodsId)"></med-icon-alert-error>
      <ng-template #validationTip>
        <div class="flex items-center h10-text">
          Містить помилки валідації
        </div>
      </ng-template>
    </div>
    </ng-template>
</med-tab-group>
  </p-scrollPanel>



<div class="background-249 flex justify-content-start p-2" style="border: 1px solid #c7c7c7; width: calc(100vw - 268px);
  border-radius: 8px; margin-top: 8px; margin-bottom: 24px">
    <div class="mr-3 h10-text black-60">LOV ID: <span class="black-80">{{optionsModel?.lovId}}</span></div>
    <div class="mr-3 h10-text black-60">МНН ID: <span class="black-80">{{optionsModel?.mnnId}}</span></div>
    <div class="mr-3 h10-text black-60" style="display: flex">МНН:&nbsp;<div class="black-80 truncate-15em">{{optionsModel?.mnnName}}</div></div>
    <div class="mr-3 h10-text black-60">Дозування: <span class="black-80">{{optionsModel?.dosage}}</span></div>
    <div class="mr-3 h10-text black-60">Кратність: <span class="black-80">{{optionsModel?.multiple}}</span></div>
    <div class="mr-3 h10-text black-60">Вартість за одиницюб грн: <span class="black-80">{{optionsModel?.cost}}</span></div>
    <div class="mr-3 h10-text black-60">Одиниця виміру: <span class="black-80">{{optionsModel?.unit}}</span></div>
    <div class="mr-3 h10-text black-60">Залишок у запасі: <span class="black-80">{{optionsModel?.remainQuantity}}</span></div>
</div>



<div class="table-wrapper" style="height: 100%; margin-bottom: 108px" *ngIf="!showRegionTable">
    <p-table
        #dt
        styleClass="p-datatable-sm"
        [scrollable]="true"
        scrollHeight="flex"
        [value]="tableRegionRecipient ? tableRegionRecipient : []"
        [customSort]="true"
        [lazy]="true"
        [resizableColumns]="true"
        columnResizeMode="expand"
        [columns]="tabHeader"
        [reorderableColumns]="true"
        (onColResize)="handleColumnResize($event)"
        (onColReorder)="saveColumnOrder('distributionColumnOrder', tabHeader)">
        <ng-template pTemplate="header">
            <tr>
                <ng-container *ngFor="let column of tabHeader">
                <th class="table-header-text table-header-bg-grey" *ngIf="column.key !== '8' || !READONLY" pReorderableColumn pResizableColumn>
                    <div style="display: inline-block" [style.width]="column.width" class="flex align-items-center h9-text" *ngIf="!['Залишки','100% потреба профінансовано'].includes(column.label)">
                        {{ column.label }}&nbsp;
                    </div>

                  <div style="display: inline-block" [style.width]="column.width" class="flex align-items-center flex-between" *ngIf="column.label === 'Залишки'">
                    <div style="margin-right: 1em">
                      {{ column.label }}&nbsp;
                    </div>
                    <div>
                      <med-btn skin="white" (click)="updateRemnants()" [pTooltip]="tooltipContentRemnants" [disabled]="updateRemnantsInProgress || READONLY">
                        <med-icon-refresh size="18" [ngClass]="{'animate--rotate': updateRemnantsInProgress}"></med-icon-refresh>
                      </med-btn>
                    </div>
                    <ng-template #tooltipContentRemnants>
                      <div class="flex items-center h10-text">
                        Оновити залишки
                      </div>
                    </ng-template>
                  </div>

                  <div style="display: inline-block" [style.width]="column.width" class="flex align-items-center flex-between" *ngIf="column.label === '100% потреба профінансовано'">
                    <div style="margin-right: 1em">
                      {{ column.label }}&nbsp;
                    </div>
                    <div>
                      <med-btn skin="white" (click)="updateDistribution100Financed()" [pTooltip]="tooltipContentFinanced" [disabled]="updateDistribution100FinancedInProgress || READONLY">
                        <med-icon-refresh size="18" [ngClass]="{'animate--rotate': updateDistribution100FinancedInProgress}"></med-icon-refresh>
                      </med-btn>
                    </div>
                    <ng-template #tooltipContentFinanced>
                      <div class="flex items-center h10-text">
                        Оновити 100% потреба профінансовано
                      </div>
                    </ng-template>
                  </div>
                </th>
            </ng-container>
              <th class="table-header-text table-header-bg-grey" *ngIf="distribution?.status === 'AWAITING_DOZ_DISTRIBUTION'">
                <div style="display: inline-block" class="flex align-items-center h9-text">
                  Заклади
                </div>
              </th>
              <th class="table-header-text table-header-bg-grey" *ngIf="distribution?.status === 'AWAITING_DOZ_DISTRIBUTION'">
                <div style="display: inline-block" class="flex align-items-center h9-text">
                  Відтерміновано, шт.
                </div>
              </th>
              <th class="table-header-text table-header-bg-grey" *ngIf="distribution?.status === 'AWAITING_DOZ_DISTRIBUTION'">
                <div style="display: inline-block" class="flex align-items-center h9-text">
                  Відтерміновано, до
                </div>
              </th>
              <th class="table-header-text table-header-bg-grey" *ngIf="distribution?.status === 'AWAITING_DOZ_DISTRIBUTION'">
                <div style="display: inline-block" class="flex align-items-center h9-text">
                  Розподіл ДОЗ
                </div>
              </th>
              <th class="table-header-text table-header-bg-grey" *ngIf="distribution?.status === 'AWAITING_DOZ_DISTRIBUTION'">
                <div style="display: inline-block" class="flex align-items-center h9-text">
                  Рішення
                </div>
              </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-columns="columns">
            <tr class="table-content-text">
                <ng-container *ngFor="let col of columns">
                <td class="h10-text black-80" [ngClass]="{'text-gray-300': !row.active}" *ngIf="col.key === '1'">
                  <div class="flex flex-between">
                    <div>{{row.regionName}}</div>
                    <div class="flex flex-between">
                      <med-icon-block size="18" class="text-red-400" [pTooltip]="tooltipBlocked" *ngIf="row.signStatus === 'Відмова'">
                      </med-icon-block>
                      <ng-template #tooltipBlocked>
                        <div class="flex items-center h10-text">
                          Відмова
                        </div>
                      </ng-template>
                      <med-icon-success size="18" class="text-green-400" [pTooltip]="tooltipApproved" *ngIf="row.signStatus === 'SIGNED'">
                      </med-icon-success>
                      <ng-template #tooltipApproved>
                        <div class="flex items-center h10-text">
                          Підтвердження
                        </div>
                      </ng-template>
                      <med-icon-visibility size="18"
                                           class="text-black-alpha-90 cursor-pointer"
                                           (click)="showRegionTabl(row.regionId)"
                                           [pTooltip]="tooltipView"
                                           *ngIf="row.signStatus === 'SIGNED'">
                      </med-icon-visibility>
                      <ng-template #tooltipView>
                        <div class="flex items-center h10-text">
                          Переглянути
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </td>
                <td class="h10-text black-80" [ngClass]="{'text-gray-300': !row.active}" *ngIf="col.key === '2'">
                  <span>{{row.requisition100}}</span>
                </td>
                <td class="h10-text black-80" [ngClass]="{'text-gray-300': !row.active}" *ngIf="col.key === '3'">
                  <span>{{row.requisitionFinanced}}</span>
                </td>
                <td class="h10-text black-60" [ngClass]="{'text-gray-300': !row.active}" *ngIf="col.key === '4'">
                  <span>{{row.remainQuantity}}</span>
                </td>

                <td class="h10-text black-80" [ngClass]="{'text-gray-300': !row.active}" *ngIf="col.key === '5'">
                  <span>{{row.initialSupply}}</span>
                </td>
                <td class="h10-text black-80" [ngClass]="{'text-gray-300': !row.active}" *ngIf="col.key === '6'">
                  <span>{{row.provisionCoefficient}}</span>
                </td>
                <td class="h10-text black-90" *ngIf="col.key === '7'">
                    <med-input  [size]="'small'"  type="number"   [(ngModel)]="row.distributedQuantity"  *ngIf="!isDistributionGoodChecked(row.distributionGoodsId) && row.active && !READONLY" [state]="getValidationState(row.id)" (focusout)="validateRegion(row)"></med-input>
                  <span *ngIf="isDistributionGoodChecked(row.distributionGoodsId) || !row.active || READONLY" [ngClass]="{'text-gray-300': !row.active}">{{row.distributedQuantity}}</span>
                </td>
                <td *ngIf="!READONLY && col.key === '8'">
                    <med-icon-visibility (mouseenter)="visibleOff.show($event)" (mouseleave)="debouncePanel(visibleOff.hide, visibleOff)" [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="activateRegionRecipient(row.id, false)" *ngIf="row.active && !isDistributionGoodChecked(row.distributionGoodsId) && !READONLY"></med-icon-visibility>
                    <med-icon-visibility-off (mouseenter)="visibleOn.show($event)" (mouseleave)="debouncePanel(visibleOn.hide, visibleOn)" class="text-gray-300" [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="activateRegionRecipient(row.id, true)" *ngIf="!row.active && !isDistributionGoodChecked(row.distributionGoodsId) && !READONLY"></med-icon-visibility-off>

                  <med-icon-visibility (mouseenter)="visibleOff.show($event)" (mouseleave)="debouncePanel(visibleOff.hide, visibleOff)" [ngStyle]="{'width': '16px'}" *ngIf="row.active && (isDistributionGoodChecked(row.distributionGoodsId) || READONLY)"></med-icon-visibility>
                  <med-icon-visibility-off (mouseenter)="visibleOn.show($event)" (mouseleave)="debouncePanel(visibleOn.hide, visibleOn)" class="text-gray-300" [ngStyle]="{'width': '16px'}" *ngIf="!row.active && (isDistributionGoodChecked(row.distributionGoodsId) || READONLY)"></med-icon-visibility-off>
                  <p-overlayPanel #visibleOff>
                    <div class="flex items-center h10-text">
                      <a href="https://www.google.com/" target="_blank">Лінк on Google</a>
                    </div>
                  </p-overlayPanel>
                  <p-overlayPanel #visibleOn>
                    <div class="flex items-center h10-text">
                      Повернути до розподілу
                    </div>
                  </p-overlayPanel>
                </td>
            </ng-container>
              <td class="h10-text black-90" style="padding: 0" *ngIf="distribution?.status === 'AWAITING_DOZ_DISTRIBUTION'">
                <div *ngFor="let beneficiary of getBeneficiarByRegionId(row.regionId)" class="small-text table-cell" style="padding-left: 16px; border-left: 1px solid #C7C7C7;">
                  {{ beneficiary.organization?.shortName }}
                </div>
              </td>

              <td class="h10-text black-90" style="padding: 0" *ngIf="distribution?.status === 'AWAITING_DOZ_DISTRIBUTION'">
                <div *ngFor="let beneficiary of getBeneficiarByRegionId(row.regionId)" class="small-text table-cell" style="padding-left: 16px;">
                  {{ beneficiary.postponedQuantity }}
                </div>
              </td>
              <td class="h10-text black-90"  style="padding: 0" *ngIf="distribution?.status === 'AWAITING_DOZ_DISTRIBUTION'">
                <div *ngFor="let beneficiary of getBeneficiarByRegionId(row.regionId)" class="small-text table-cell" style="padding-left: 16px; padding-right: 16px;">
                  <div *ngIf="beneficiary.postponedDate && beneficiary.postponedActive" class="flex flex-between">
                  {{ beneficiary.postponedDate | date: 'dd.MM.yyyy'}}
                  &nbsp;<med-icon-minus-circle
                    size="16"
                    class="text-gray-300"
                    (click)="showRemovePostponedModal(beneficiary)"
                    *ngIf="row.signStatus !== 'SIGNED' && row.signStatus !== 'AUTO_APPROVED'"
                    (mouseenter)="removePostp.show($event)" (mouseleave)="removePostp.hide()"
                  ></med-icon-minus-circle>
                    <p-overlayPanel #removePostp>
                      <div class="flex items-center h10-text">
                        Скасувати відтермінування
                      </div>
                    </p-overlayPanel>
                  </div>
                  <div style="display: inline-flex" *ngIf="beneficiary.postponedDate && !beneficiary.postponedActive">
                    <img [src]="'assets/icons/table/Statys_indicator_red.png'" width="4" height="16" style="vertical-align: middle;"/>
                    &nbsp;Скасовано
                  </div>
                </div>
              </td>
              <td class="h10-text black-90"  style="padding: 0" *ngIf="distribution?.status === 'AWAITING_DOZ_DISTRIBUTION'">
                <div *ngFor="let beneficiary of getBeneficiarByRegionId(row.regionId)" class="small-text table-cell" style="padding-left: 16px; padding-right: 16px; border-right: 1px solid #C7C7C7;">
                  {{ beneficiary.quantityDoz || 0}}
                </div>
              </td>
              <td class="h10-text black-90" *ngIf="distribution?.status === 'AWAITING_DOZ_DISTRIBUTION'">
                <div class="h10-text" style="display: inline-flex">
                  <img [src]="getPathToStatusImg(row.signStatus === 'SIGNED' || row.signStatus === 'AUTO_APPROVED' ? 'green': 'draft')" width="4" height="16" style="vertical-align: middle;"/>
                  &nbsp;{{(row.signStatus === 'SIGNED' || row.signStatus === 'AUTO_APPROVED' ) ? 'Погоджено': 'На погодженні'}}
                  &nbsp;<med-icon-info size="16" class="text-gray-300"></med-icon-info>
                </div>
              </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<div class="table-wrapper" style="height: 100%; margin-bottom: 108px" *ngIf="showRegionTable">
  <p-table
    #dt
    styleClass="p-datatable-sm"
    [scrollable]="true"
    scrollHeight="flex"
    [value]="distributionForRegion.goodSpecifications"
    [customSort]="true"
    [lazy]="true"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [columns]="tabHeaderDoz"
    [reorderableColumns]="true"
    (onColReorder)="saveColumnOrder('distributionDozColumnOrder', tabHeader)">
    <ng-template pTemplate="header">
      <tr>
        <ng-container *ngFor="let column of tabHeaderDoz">
          <th class="table-header-text table-header-bg-grey" pReorderableColumn pResizableColumn>
            <div style="display: inline-block" class="flex align-items-center no-wrap"
                 [ngStyle]="{
            'max-width': ['2', '3', '4'].includes(column.key) ? '13em' : 'unset',
            'min-width': ['2', '3', '4'].includes(column.key) ? '13em' : '3em'
          }"
            >
              {{ column.label }}
            </div>
          </th>

        </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row  let-columns="columns">
      <tr class="table-content-text">
        <ng-container *ngFor="let col of columns">
          <td class="h10-text black-80" *ngIf="col.key === '1'">
            <span>{{row.good.mnnName}}</span>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === '2'">
            <span>{{row.distributedQuantity}}</span>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === '3'">
            <span>{{row.requisitions100}}</span>
          </td>
          <td class="h10-text black-60" *ngIf="col.key === '4'">
            <span>{{row.requisitionsFinanced}}</span>
          </td>

          <td class="h10-text black-80" *ngIf="col.key === '5'">
            <span>{{row.remnants}}</span>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === '6'">
            <ul style="list-style: none;padding-left: 0;padding-top: 0">
              <li *ngFor="let series of row.seriesCatalogues" class="small-text">
                {{ series }}
              </li>
            </ul>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === '7'">
            <span>{{ row.good.releaseForm }}</span>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === '8'">
            <span>{{row.good.unit}}</span>
          </td>
          <td class="h10-text black-90" style="padding: 0" *ngIf="col.key === '9'">
            <div *ngFor="let beneficiary of row.beneficiaries" class="small-text table-cell" style="padding-left: 16px; border-left: 1px solid #C7C7C7;">
              <med-input  [size]="'small'"  type="number"   [(ngModel)]="beneficiary.quantityDoz" ></med-input>
            </div>
          </td>
          <td class="h10-text black-80" style="padding: 0" *ngIf="col.key === '10'">
            <div *ngFor="let beneficiary of row.beneficiaries" class="small-text table-cell" style="padding-left: 16px; padding-right: 16px;">
              {{ beneficiary.organization.shortName }}
            </div>
          </td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</div>

<div
        [style.width]="'calc(100vw - 0px)'"
        [style.height]="'60px'"
        class="med-layout__footer"
>
    <div class="med-layout__footer-content">
        <div class="flex flex-center flex-between">
            <div class="flex flex-center">
            <med-btn class="mr-1" (click)="goToSeries()" *ngIf="!READONLY">
                <med-icon-plus size="16"></med-icon-plus>
                &nbsp;
                <span>Серії/Каталожні номери</span>
            </med-btn>
            <med-btn class="mr-1" (click)="provisionCoefficientModal = true;" *ngIf="!READONLY">
                <span>Коефіцієнт забезпеченості</span>
            </med-btn>
            <med-btn class="mr-1" (click)="distributeAll()" [disabled]="isAnyDistributionGoodIdChecked()" *ngIf="!READONLY">
                <span>Розподілити все</span>
            </med-btn>
              <med-btn class="mr-1" *ngIf="showRegionTable" (click)="showRegionTable = false">
                <med-icon-redo size="16"></med-icon-redo>
                &nbsp;
                <span>До розподілу</span>
              </med-btn>
            <med-btn class="mr-1" (click)="openAttachmentsModal()">
                Вкладення
                &nbsp;
                {{ attachments.content.length }}
            </med-btn>
                <med-btn class="mr-1" (click)="openComponentsModal()">
                    Комплектуючі
                    &nbsp;
                    {{ components.content.length }}
                </med-btn>
            <med-btn class="mr-1" (click)="reviewModal = true">
                <med-icon-bulb size="16"></med-icon-bulb>
                &nbsp;
                <span>Перегляд</span>
            </med-btn>
            <med-btn class="mr-1" (click)="openDownloadExcelModal()">
                <med-icon-download size="16" (mouseenter)="downloadExcelPanel.show($event)" (mouseleave)="downloadExcelPanel.hide()"></med-icon-download>
                &nbsp;
              <p-overlayPanel #downloadExcelPanel>
                <div class="flex items-center h10-text">
                  Завантажити
                </div>
              </p-overlayPanel>
                <span></span>
            </med-btn>
            </div>
            <div class="flex flex-center" *ngIf="!READONLY">
            <med-btn class="mr-1" (click)="archive()">
                <med-icon-archive size="16"></med-icon-archive>
                &nbsp;
                <span>Архівувати</span>
            </med-btn>
                <med-btn class="mr-1" (click)="save()">
                    <med-icon-archive size="16"></med-icon-archive>
                    &nbsp;
                    <span>Зберегти</span>
                </med-btn>

            <med-btn skin="yellow" *ngIf="toAgree"   (click)="distributionAgreementModal = true">
                <span>Погодити</span>
                &nbsp;
                <med-icon-check-circle size="16"></med-icon-check-circle>
            </med-btn>
            </div>
            <div class="flex flex-center" *ngIf="distribution?.status === 'PENDING_APPROVAL'">
              <med-btn class="mr-1" (click)="backToDraftConfirmationModal=true">
                <med-icon-arrow-circle-left size="16"></med-icon-arrow-circle-left>
                &nbsp;
                <span>Повернути на доопрацювання</span>
              </med-btn>
              <med-btn skin="yellow" *ngIf="!toAgree" (click)="showSentToDozModal()">
                <span>Відправити в ДОЗ</span>
                &nbsp;
                <med-icon-arrow-right size="16"></med-icon-arrow-right>
              </med-btn>
            </div>
        </div>
    </div>
</div>
</ng-template>
<med-modal
        [(visible)]="provisionCoefficientModal"
        [closeableOutside]="false"
>
    <div class="em-25">
        <div class="flex flex-center mb-4">
            <med-icon-comments
                    size="36"
                    mode="square"
            ></med-icon-comments>

            <h6 class="text extra-large ml-2 mb-0 mt-0">
                Коефіцієнт забезпеченості
            </h6>
        </div>
        <div class="text-h10-left mt-3">
            Даний коефіцієнт забезпеченості буде застосовано для всіх регіонів
        </div>

        <div class="mt-3">
            <med-input
                    [(ngModel)]="newProvisionCoefficient"
                    type="number"
                    [precision]="2"
                    label="Kоефіцієнт забезпеченості"
                    placeholder="Введіть коефіцієнт"
            ></med-input>
        </div>
        <div class="mt-4 flex flex-between flex-center">
            <div class="mt-1 width-100">
                <med-btn skin="gray" (click)="provisionCoefficientModal = false" class="width-100">Скасувати</med-btn>
            </div>
            <div class="mt-1 width-100 ml-2">
                <med-btn (click)="editProvisionCoefficient()" class="width-100" [disabled]="!newProvisionCoefficient">Підтвердити</med-btn>
            </div>
        </div>
    </div>
</med-modal>

<med-modal
        [(visible)]="attachmentsModal"
>
    <div>
        <div class="flex flex-center mb-4">
            <med-icon-docs
                    size="36"
                    mode="square"
            ></med-icon-docs>

            <h6 class="text extra-large ml-2 mb-0 mt-0">
                Вкладення
            </h6>
        </div>

      <app-loader *ngIf="attachments.isLoading"></app-loader>
      <div class="table-wrapper" style="height: unset" *ngIf="!attachments.isLoading">
            <p-table
                #dt
                styleClass="p-datatable-sm"
                [scrollable]="true"
                scrollHeight="flex"
                [value]="attachments.content"
                [customSort]="true"
                [lazy]="true"
                [tableStyle]="{ 'width': '100%' }"
                [resizableColumns]="true"
                columnResizeMode="expand"
                [columns]="attachmentsTabHeader"
                [reorderableColumns]="true"
                (onColReorder)="saveColumnOrder('attachemntsColumnOrder', attachmentsTabHeader)">

                <ng-template pTemplate="header">
                    <tr>
                        <ng-container *ngFor="let column of attachmentsTabHeader">
                            <th class="mobile-h10-text table-header-bg-grey" pReorderableColumn pResizableColumn>
                                <div style="display: inline-block" class="flex align-items-center h9-text">
                                    {{ column.label }}&nbsp;
                                </div>
                            </th>
                    </ng-container>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row let-columns="columns">
                    <tr class="table-content-text">
                        <ng-container *ngFor="let col of columns">
                        <td class="black-80 h9-text" *ngIf="col.key === '1'">
                          {{ row.type }}
                        </td>
                        <td class="black-60 h10-text" *ngIf="col.key === '2'">
<!--                            <med-upload-file-->
<!--                                    [hideClearBtn]="true"-->
<!--                                    size="small"-->
<!--                                    accept=".pdf, .xls, .xlsx, .doc, .docx, .rtf, .txt, .ppt, .pptx"-->
<!--                                    [binary]="true"-->
<!--                                    placeholder="Виберіть файл"-->
<!--                                    (onInput)="onFileInput($event)"-->
<!--                            ></med-upload-file>-->
                          {{row.fileName}}
                        </td>
                        <td class="black-80 h9-text" *ngIf="col.key === '3'">
                           {{ row.fileNumber }}
                        </td>
                        <td class="black-80 h9-text" *ngIf="col.key === '4'">
                            {{ row.selectedDate | date: 'dd.MM.yyyy' }}
                        </td>

                        <td class="black-80 h9-text" *ngIf="col.key === '5'">
                          {{row.owner}}
                        </td>
                        <td *ngIf="col.key === '6'">
                            <med-btn size="small" skin="white">
                                <med-icon-download size="16" (click)="downloadFile(row)" (mouseenter)="downloadFilePanel.show($event)" (mouseleave)="downloadFilePanel.hide()"></med-icon-download>
                              <p-overlayPanel #downloadFilePanel>
                                <div class="flex items-center h10-text">
                                  Завантажити
                                </div>
                              </p-overlayPanel>
                            </med-btn>
                        </td>
                    </ng-container>
                    </tr>
                </ng-template>

            </p-table>
        </div>
    </div>
</med-modal>

<med-modal
        [(visible)]="reviewModal">
  <app-view-distribution-modal [distributionId]="distributionId" [isDoz]="false"></app-view-distribution-modal>
</med-modal>


<med-modal
        [(visible)]="distributionAgreementModal"
        class="no-padding"
>
    <div style="width: 383px; height: 316px; padding: 32px">
        <div class="flex justify-content-center">
            <med-icon-check-circle-fill [ngStyle]="{'width': '32px'}"></med-icon-check-circle-fill>
        </div>
        <div class="text-h6-heading" style="margin-top: 12px">
            Ви впевнені, що бажаєте погодити даний розподіл?
        </div>
        <div class="text-h10-center" style="margin-top: 12px">
            Подальші зміни розподілу стануть недоступні.
        </div>
        <div style="margin-top: 32px">
            <div>
                <med-btn (click)="approve()" class="width-100">Погодити</med-btn>
            </div>
            <div class="mt-1">
                <med-btn skin="gray" (click)="distributionAgreementModal = false" class="width-100">Скасувати</med-btn>
            </div>
        </div>
    </div>
</med-modal>

<med-modal
  [(visible)]="backToDraftConfirmationModal"
  class="no-padding"
>
  <div style="width: 383px; height: 316px; padding: 32px">
    <div class="flex justify-content-center">
      <med-icon-check-circle-fill [ngStyle]="{'width': '32px'}"></med-icon-check-circle-fill>
    </div>
    <div class="text-h6-heading" style="margin-top: 12px">
      Ви впевнені, що бажаєте повернути розподіл на доопрацювання?
    </div>
    <div style="margin-top: 32px">
      <div>
        <med-btn (click)="backToDraft()" class="width-100">Повернути на доопрацювання</med-btn>
      </div>
      <div class="mt-1">
        <med-btn skin="gray" (click)="backToDraftConfirmationModal = false" class="width-100">Скасувати</med-btn>
      </div>
    </div>
  </div>
</med-modal>

<med-modal
        [(visible)]="sendToDOZModal"
        [closeableOutside]="false"
        class="no-padding"
        (close)="toggleModal(false)"
>
    <div class="toDOZModal">
        <div class="modalHeader">
            <med-icon-comments size="36"></med-icon-comments>
            <span class="text-h6-heading">Відправка розподілу в ДОЗ</span>
        </div>
        <div style="margin-top: 40px; display: flex; flex-direction: row">
            <div style="width: 480px; flex-direction: column">
                <div class="flex flex-between flex-center">
                    <span class="h7-heading">
                        Вкладення
                    </span>
                    <span class="h10-text black-60">
                        Обов'язково<span class="asterisk">*</span>
                    </span>
                </div>

              <p-scrollPanel [style]="{ 'height': '494px' }">
                <div style="margin-top: 16px">
                    <med-card>
                        <div class="flex flex-between flex-center">
                            <med-radio-group position="horizontal" [options]="options" [value]="value" [(ngModel)]="fileAttachments[0].type"></med-radio-group>
                            <med-icon-close style="cursor: pointer" *ngIf="fileAttachments.length > 1" (click)="deleteAttachment()"></med-icon-close>
                        </div>
                        <div style="margin-top: 24px" class="flex flex-between flex-center">
                            <div style="width: 50%">
                                <med-input label="Номер документу" [placeholder]="fileAttachments[0].type ? 'Введіть номер' : ''" [(ngModel)]="fileAttachments[0].number" [disabled]="!fileAttachments[0].type"></med-input>
                            </div>
                            <div style="width: 50%; margin-left: 10px">
                                <med-datepicker  label="Дата" [(ngModel)]="fileAttachments[0].selectedDate" [disabled]="!fileAttachments[0].number" [state]="fileAttachmentsDateState" (ngModelChange)="validateFileAttachmentDate($event)"></med-datepicker>
                            </div>
                        </div>
                        <div style="margin-top: 24px" *ngFor="let attachment of fileAttachments; let i = index">
                            <div style="width: 100%">
                              <med-upload-file
                                [disabled]="!attachment.number || !attachment.type || !attachment.selectedDate"
                                [hideClearBtn]="true"
                                accept=".pdf, .xls, .xlsx, .doc, .docx, .rtf, .txt, .ppt, .pptx"
                                [binary]="true"
                                placeholder="Завантажити файл"
                                (onInput)="onFileInput($event, i)"
                              ></med-upload-file>
                            </div>
                        </div>
                    </med-card>
                </div>
              </p-scrollPanel>
                <div style="margin-top: 16px">
                    <med-btn skin="gray" size="small" (click)="addFileAttachment()"  [disabled]="isAddAttachmentDisabled" [ngStyle]="isAddAttachmentDisabled ? {'pointer-events': 'none'} : {}">
                        <med-icon-plus [ngStyle]="{'width': '16px'}" size="small"></med-icon-plus>
                        <span class="attach-btn-text ml-4px">
                          Додати ще вкладення
                      </span>
                    </med-btn>
                </div>
            </div>

            <div style="margin-left: 40px; width: 480px">
                <div class="flex flex-between flex-center">
                    <span class="h7-heading">
                        Контрольні дати
                    </span>
                    <span class="h10-text black-60">
                        Заповніть за потреби
                    </span>
                </div>
              <div class="table-wrapper" style="width: 479px!important;">
                <p-table
                  styleClass="p-datatable-sm"
                  [scrollable]="true"
                  scrollHeight="494px"
                  [value]="goodsLovControlDateList"
                  [resizableColumns]="true"
                  columnResizeMode="expand"
                  [columns]="datesTabHeader"
                  [reorderableColumns]="true"
                  (onColReorder)="saveColumnOrder('datesColumnOrder', datesTabHeader)">
                  <ng-template pTemplate="header">
                    <tr>
                        <ng-container *ngFor="let column of datesTabHeader">
                            <th class="table-header-text table-header-bg-grey" style="min-width: 10em" pReorderableColumn pResizableColumn>
                                {{ column.label }}&nbsp;
                            </th>
                        </ng-container>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-row let-columns="columns">
                    <tr style="background: #f9f9f9">
                        <ng-container *ngFor="let col of columns">
                            <td class="h10-text black-80" *ngIf="col.key === '1'">{{row.mnnName}}</td>
                            <td class="h10-text black-60" *ngIf="col.key === '2'">{{row.mnnId}}</td>
                            <td *ngIf="col.key === '3'">
                              <med-datepicker placeholder="дд.мм.рррр"  [(ngModel)]="row.controlDate" [state]="row.clientValidationState" (ngModelChange)="validateControlDate($event, row)"></med-datepicker>
                            </td>
                        </ng-container>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
        </div>


        <div class="flex flex-center" style="margin-top: auto; margin-left: auto; margin-right: auto">
            <div>
                <med-btn class="action-btn" skin="gray" (click)="closeSendToDozModal()" >Скасувати</med-btn>
            </div>
            <div style="margin-left: 16px">
<!--              todo: uncoment before release-->
<!--                <med-btn class="action-btn" (click)="sendToDoz()"  [disabled]="sendingToDOZ">-->
<!--                  <med-icon-sync-->
<!--                    *ngIf="sendingToDOZ"-->
<!--                    size="20"-->
<!--                    class="animate&#45;&#45;rotate mr-2"-->
<!--                  ></med-icon-sync>-->
<!--                    Відправити в ДОЗ-->
<!--                    &nbsp;<med-icon-arrow-right [ngStyle]="{'width': '16px'}"></med-icon-arrow-right>-->
<!--                </med-btn>-->
              <med-btn class="action-btn" (click)="sendToDoz()">
                Відправити в ДОЗ
                &nbsp;<med-icon-arrow-right [ngStyle]="{'width': '16px'}"></med-icon-arrow-right>
              </med-btn>
            </div>
        </div>
    </div>
</med-modal>

<med-modal
        [(visible)]="componentsModal"
>
    <div>
        <div class="flex flex-center mb-4">
            <med-icon-docs
                    size="36"
                    mode="square"
            ></med-icon-docs>

            <h6 class="text extra-large ml-2 mb-0 mt-0">
                Комплектуючі
            </h6>
        </div>

        <app-loader *ngIf="components.isLoading"></app-loader>
        <div class="table-wrapper" style="height: unset" *ngIf="!components.isLoading">
            <p-table
                #dt
                styleClass="p-datatable-sm"
                [scrollable]="true"
                scrollHeight="flex"
                [value]="components.content"
                [customSort]="true"
                [lazy]="true"
                [tableStyle]="{ 'width': '100%' }"
                [resizableColumns]="true"
                columnResizeMode="expand"
                [columns]="componentsTabHeader"
                [reorderableColumns]="true"
                (onColReorder)="saveColumnOrder('componentsColumnOrder', componentsTabHeader)">

                <ng-template pTemplate="header">
                    <tr>
                        <ng-container *ngFor="let column of componentsTabHeader">
                            <th class="mobile-h10-text table-header-bg-grey" pReorderableColumn pResizableColumn>
                                <div style="display: inline-block" class="flex align-items-center h9-text">
                                    {{ column.label }}&nbsp;
                                </div>
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row let-columns="columns">
                    <tr class="table-content-text">
                        <ng-container *ngFor="let col of columns">
                            <td class="black-80 h9-text" *ngIf="col.key === '1'">
                                {{ row.trade_name }}
                            </td>
                            <td class="black-60 h10-text" *ngIf="col.key === '2'">
                                {{ row.due_date }}
                            </td>
                            <td class="black-80 h9-text" *ngIf="col.key === '3'">
                                {{ row.quantity }}
                            </td>
                            <td class="black-80 h9-text" *ngIf="col.key === '4'">
                                {{ row.series_catalogue }}
                            </td>
                        </ng-container>
                    </tr>
                </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td class="h8-text background-249" style="width: 100%; text-align: center" [attr.colspan]="componentsTabHeader.length">
                    Немає комплектуючих
                  </td>
                </tr>
              </ng-template>

            </p-table>
        </div>
    </div>
</med-modal>
<med-modal
  [(visible)]="downloadExcelModal"
>
  <div class="em-50">
    <div class="grid">
      <div class="col-2">
        <med-icon-docs
          size="48"
          mode="square"
        ></med-icon-docs>
      </div>

      <div class="col-10 p-grid justify-content-center align-content-center">
        <span class="white-space-nowrap text-h6-heading">
          Завтантажити розподіл
        </span>
      </div>
    </div>

    <br/>
    <br/>

    <div class="grid">
      <div class="col-12">
        <span class="white-space-nowrap text-h7-left">
          Оберіть тип файлу, який ви бажаєте завантажити
        </span>
      </div>
    </div>

    <br/>

    <div class="grid">
      <div class="col-12">
        <med-radio-group position="" class="report_options_radiogroup" [options]="downloadReportOptions" [value]="downloadReportValue" (onInput)="downloadReportOptionChanged($event)"></med-radio-group>
      </div>
    </div>

    <br/>

    <div class="grid">
      <div class="col-5">
        <med-btn class="width-100" size="large" skin="gray" (click)="cancelDownloadReport()" >Скасувати</med-btn>
      </div>
      <div class="col-5">
        <med-btn class="width-100" size="large" skin="" (click)="downloadExcel()">Підтвердити</med-btn>
      </div>
    </div>


  </div>
</med-modal>

<med-modal
  [(visible)]="removePostponedModal"
  class="no-padding"
>
  <div style="width: 388px; height: 316px; padding: 32px">
    <div class="flex justify-content-center">
      <med-icon-check-circle-fill [ngStyle]="{'width': '32px'}"></med-icon-check-circle-fill>
    </div>
    <div class="text-h6-heading" style="margin-top: 12px">
      Ви впевнені, що бажаєте скасувати відтермінування?
    </div>
    <div class="h10-text mt-2" style="text-align: center; color: #666666">
      Ця дія поверне товар до активного розподілу.
    </div>
    <div style="margin-top: 32px">
      <div>
        <med-btn (click)="removePostponed()" class="width-100">Так, скасувати</med-btn>
      </div>
      <div class="mt-1">
        <med-btn skin="gray" (click)="removePostponedModal = false" class="width-100">Відміна</med-btn>
      </div>
    </div>
  </div>
</med-modal>
